<template>
	<div class="landbouwquiz">
		<div class="tekst">
			<h2 v-html="getContent(content.blokken[2].tussenkop1)"></h2>
				
			<p v-html="getContent(content.blokken[2].tekst1)"></p>
		</div>

		<div class="bol-wit-wrapper">
			<div class="bol-wit"></div>
		</div>
		<div class="quizvragen">
			<div v-for="(quizvraag, index) in quiz" :key="quizvraag">
				<h2 v-html="quizvraag.vraag"></h2>

				<div class="antwoord" :id="'vraag_' + index"></div>

				<div class="knd-quiz-buttons">
					<div :class="'knd-button quiz optie_' + index" @click="getResult(index, 'A', $event)">{{ quizvraag.opties['A'] }}</div>
					<div :class="'knd-button quiz optie_' + index" @click="getResult(index, 'B', $event)">{{ quizvraag.opties['B'] }}</div>
					<div :class="'knd-button quiz optie_' + index" @click="getResult(index, 'C', $event)">{{ quizvraag.opties['C'] }}</div>
				</div>
			</div>
		</div>

		<div class="tekst">
			<p v-html="getContent(content.blokken[2].tekst2)"></p>
		</div>
	</div>
</template>

<script>
	import './landbouwquiz.scss';

	export default {
		name: 'Landbouwquiz',
		props: [],
		data: function() {
			return {
				voetbalvelden: 244000,
				procent: 5.6,
				content: this.$store.state.content,
				quiz: [
					{
						vraag: "Hoeveel landbouwgrond is er verdwenen, uitgedrukt in voetbalvelden?",
						opties: {
							A: "5.400",
							B: "56.300",
							C: "244.000"
						},
						antwoorden: {
							A: "Fout! Er is veel landbouwgrond verdwenen: 244.000 voetbalvelden",
							B: "Fout! Er is veel landbouwgrond verdwenen: 244.000 voetbalvelden",
							C: "Dat klopt"
						}
					},
					{
						vraag: "Hoeveel procent is dat van het totaal aan landbouwgrond denk je?",
						opties: {
							A: "5,6%",
							B: "10,3%",
							C: "23,8%"
						},
						antwoorden: {
							A: "Dat klopt",
							B: "Fout! Er is 5,6% aan landbouwgrond verdwenen",
							C: "Fout! Er is 5,6% aan landbouwgrond verdwenen"
						}
					}
				]
			}
		},
		methods: {
			getContent(content) {
			// if (this.$store.state.language === "nl") {
				return content.data;
			// }
			// else {
				// return content[label].data5891;	
			// }
			},

			getResult(index, optie, evt) {
				const resultContainer = document.querySelector("#vraag_" + index);
				resultContainer.innerHTML = this.quiz[index].antwoorden[optie];
				
				const buttons = document.querySelectorAll(`.optie_${CSS.escape(index)}`);
				console.log(buttons);
				buttons.forEach((button) => {
					button.classList.remove("active");
				});
				evt.target.classList.add("active");
			}
		},
		mounted: function() {
			// console.log("landbouwquiz geladen");
		}
	}
</script>